module.exports = __webpack_public_path__ + "static/media/hinted-Whitney-Book.b418963d.eot";